import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "ai",
    iconColor: "white",
    text: "AI-powered search",
    listItemCustomStyle: { width: "290px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithLight2",
    iconColor: "white",
    text: "Gen-AI powered \ncontent generation \nand messaging",
    listItemCustomStyle: { width: "271px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithGraph",
    iconColor: "white",
    text: "Consumer knowledge \ngraph to drive \ncontextualization",
    listItemCustomStyle: { width: "271px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_AI_TWIN_2 = {
  title: "50% INCREASE IN REACH WITH AI \nINFUSED PERSONALIZATION",
  titleNumber: "2.",
  text: "Improved search relevance, personalized content generation and contextualized \nmessaging by capturing micro moments to drive consumer affinity.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("AITWIN_304"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("AITWIN_302"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "AI_TWIN/AI_Twin_03.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "AI_TWIN/InfosysTopazLogo.png",
};
